export function Marquee({ text }) {
  const content = Array(8).fill(text);
  return (
    <div className="bg-foreground text-background py-2.5 overflow-hidden whitespace-nowrap">
      <div className="inline-flex animate-marquee">
        {[...content, ...content].map((t, i) => (
          <span key={i} className="mx-6 text-xs font-bold uppercase tracking-[0.25em] font-mono">{t}<span className="text-accent ml-6">✦</span></span>
        ))}
      </div>
    </div>
  );
}

export function AdBanner({ banner }) {
  return (
    <section data-testid={`ad-banner-${banner.id}`} className="relative w-full bg-accent text-accent-foreground overflow-hidden">
      <div className="max-w-[1500px] mx-auto grid grid-cols-1 md:grid-cols-2 items-center">
        <div className="p-10 sm:p-16">
          <div className="text-xs font-bold uppercase tracking-[0.25em] opacity-80">Partner Product</div>
          <h2 className="font-heading font-black text-4xl sm:text-5xl tracking-tighter uppercase mt-3 leading-none">{banner.title}</h2>
          <p className="mt-4 text-base max-w-md opacity-90">{banner.subtitle}</p>
          <a
            href={banner.link || "#"}
            data-testid={`ad-banner-cta-${banner.id}`}
            target={banner.link && banner.link.startsWith("http") ? "_blank" : undefined}
            rel="noreferrer"
            className="inline-block mt-6 bg-foreground text-background px-8 py-3.5 text-xs font-bold uppercase tracking-[0.2em] hover:bg-black/80 transition-colors"
          >
            {banner.cta || "Shop Now"}
          </a>
        </div>
        <div className="relative h-64 md:h-80 overflow-hidden">
          <img src={banner.image} alt={banner.title} className="w-full h-full object-cover mix-blend-luminosity opacity-90" />
        </div>
      </div>
    </section>
  );
}
